<span class="git-branch-name-badge">
  <fa-icon [icon]="['fal', 'code-branch']"></fa-icon>
  <span class="ml-space">
    {{ name }}
  </span>
</span>
